<div class="container">
  <h1>404</h1>
  <p class="lead">Page non trouvée.</p>

  <button type="button" mat-stroked-button color="primary" class="btn-md" (click)="onBackPage()">
    Retour
  </button>
</div>
